import React from 'react';

import { Tag as ChakraTag } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { isMobileView } from 'constants/isMobileView';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const TAG_VARIANT = {
  filled: 'filled', // <- v1
  outlined: 'outlined', // <- v2
};

const TransientProps = ['variant'];

const getBaseStyles = (theme, props) => ({
  backgroundColor: theme.colors.neutral.EBEFF3,
  border: `1px solid transparent`,
  p: {
    color: theme.colors.text.g2,
    userSelect: 'none',
  },
  cursor: 'pointer',
});

const StyledTag = styled(ChakraTag, {
  shouldForwardProp: (prop) => !TransientProps.includes(prop),
})(({ theme, ...props }) => ({
  ...getBaseStyles(theme, props),
  '&.is-selected': {
    backgroundColor:
      props?.variant === TAG_VARIANT.filled ? theme.colors.button.blue.default : theme.colors.functional.E6F1FD,
    border: props?.variant === TAG_VARIANT.outlined && `1px solid ${theme.colors.button.blue.focus}`,
    p: {
      color: props?.variant === TAG_VARIANT.filled ? theme.colors.common.white : theme.colors.button.blue.focus,
    },
    '&:hover:disabled': {
      backgroundColor: theme.colors.functional.E6F1FD,
    },
  },
}));

export const Chip = ({
  isFeedbackChip = false,
  children,
  variant = TAG_VARIANT.filled,
  StartIcon,
  showCloseButton, // <- need to get close icon
  // selected means render in active state
  selected = false,
  className = '',
  ...props
}) => {
  const hasStartIcon = !!StartIcon;
  const labelMargins = hasStartIcon ? '0 8px 0 4px' : '0 8px 0 8px';
  return (
    <StyledTag
      borderRadius="full"
      colorScheme="green"
      variant={variant}
      className={selected ? 'is-selected' : ''}
      mb={isMobileView() && isFeedbackChip && '10px'}
      {...props}
    >
      {hasStartIcon && <StartIcon color={selected ? '#104F95' : '#666666'} />}
      {isMobileView() && isFeedbackChip ? (
        <TextLabel bold m={labelMargins}>
          {children}
        </TextLabel>
      ) : (
        <TextBodyMedium bold m={labelMargins}>
          {children}
        </TextBodyMedium>
      )}
    </StyledTag>
  );
};
